<script>
export default {
  name: 'overlay.generic'
}
</script>
<template>
  <b-overlay
    v-bind="$attrs"
    v-on="$listeners"
    rounded="sm"
    :opacity="0.8"
    variant="white"
    spinner-variant="dark"
  >
    <!-- Pass on all named slots -->
    <slot v-for="slot in Object.keys($slots)" :name="slot" :slot="slot" />

    <!-- Pass on all scoped slots -->
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
      ><slot :name="slot" v-bind="scope"
    /></template>
  </b-overlay>
</template>
